module.exports = __webpack_public_path__ + "static/img/d5079f9f5edd81ab71b06fccbfb0f51f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bk_box.png
// module id = nKKK
// module chunks = 1